/*
  /register — deep-linkable page wrapper around AuthForm. Mirror of LoginPage.
*/
import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import AuthForm from "../components/AuthForm";
import { useAuth } from "../contexts/AuthContext";

export default function RegisterPage() {
  const { user, loading } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!loading && user) nav("/", { replace: true });
  }, [user, loading, nav]);

  return (
    <div className="max-w-md mx-auto w-full py-8" data-testid="register-page">
      <div className="mb-6">
        <h1 className="font-display tracking-tighter text-3xl mb-1" style={{ color: "var(--primary-ink)" }}>
          Create your account
        </h1>
        <p className="text-sm" style={{ color: "var(--text-muted)" }}>
          Your current data on this device will be linked to the new account automatically.
        </p>
      </div>
      <div className="card-tactile rounded-2xl p-5">
        <AuthForm initialMode="register" onDone={() => nav("/", { replace: true })} onForgot={() => nav("/forgot-password")} />
      </div>
      <p className="text-center text-xs mt-4" style={{ color: "var(--text-muted)" }}>
        <Link to="/" className="hover:underline">← Back to Hub</Link>
      </p>
    </div>
  );
}
